import {Input, InputNumber} from "antd";
import className from "classnames/bind";
import NestedFieldGroup from "./NestedFieldGroup";
import RepeatableField from "./RepeatableField";
import style from "../style/SchemaTool.module.scss";

const cn = className.bind(style);

/**
 * Renderer đệ quy cho danh sách field theo định nghĩa schema (definitions.js).
 *
 * Controlled: `values` (object) + `onChange(name, value)` do cha sở hữu.
 * - scalar → input antd.
 * - object → <NestedFieldGroup> (đệ quy lại component này).
 * - array  → <RepeatableField> (đệ quy lại component này).
 *
 * Lưu ý: import vòng với NestedFieldGroup/RepeatableField là CỐ Ý (recursive
 * component) — chỉ tham chiếu lúc render nên webpack xử lý được.
 */
function SchemaFieldList({fields, values = {}, onChange}) {

	const set = (name, val) => onChange({...values, [name]: val});

	return (
		<div className={cn('field-list')}>
			{fields.map((f) => {
				if (f.type === 'object') {
					return (
						<NestedFieldGroup
							key={f.name}
							field={f}
							value={values[f.name] || {}}
							onChange={(v) => set(f.name, v)}
						/>
					);
				}

				if (f.type === 'array') {
					return (
						<RepeatableField
							key={f.name}
							field={f}
							value={Array.isArray(values[f.name]) ? values[f.name] : []}
							onChange={(v) => set(f.name, v)}
						/>
					);
				}

				return (
					<div className={cn('field')} key={f.name}>
						<label className={cn('field-label')}>
							{f.label}
							{f.required && <span className={cn('req')}> *</span>}
							{f.rich && <span className={cn('rich-badge')}>rich result</span>}
						</label>
						<ScalarInput field={f} value={values[f.name]} onChange={(v) => set(f.name, v)} />
					</div>
				);
			})}
		</div>
	);
}

/** Input theo type scalar. */
function ScalarInput({field, value, onChange}) {
	const common = {
		value: value ?? '',
		placeholder: field.label,
		onChange: (e) => onChange(e?.target ? e.target.value : e),
	};

	if (field.type === 'textarea') {
		return <Input.TextArea {...common} rows={3} />;
	}

	if (field.type === 'number') {
		return (
			<InputNumber
				style={{width: '100%'}}
				value={value ?? null}
				placeholder={field.label}
				onChange={(v) => onChange(v)}
			/>
		);
	}

	if (field.type === 'date') {
		return <Input {...common} placeholder="YYYY-MM-DD" />;
	}

	if (field.type === 'datetime') {
		return <Input {...common} placeholder="YYYY-MM-DD hoặc 2026-01-31T09:00" />;
	}

	return <Input {...common} type={field.type === 'tel' ? 'tel' : 'text'} />;
}

export default SchemaFieldList;
